import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import parse from 'html-react-parser';
import PopupComponents from '../Popcomponent/popupComponents.js';
import FadeIn from "react-lazyload-fadein";
import placeholder from '../../assests/images/horPlaceholder.jpg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ZoomThumbnail from './zoomThumbnail.js';

class TopPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMoreDesState: '',
            showPopup: false,
            settings: {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 900,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 2500,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 2000,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },

                ],
            },
            Muted: false,
            isVideoThumbonHover: false,
            thumbnailIndex: 0
        }
    }


    showMoreDes = (des) => {
        document.body.classList.add('overflow-hidden');
        this.setState({ showPopup: true });
        this.setState({ showMoreDesState: des });
    }
    hidePopup = () => {
        document.body.classList.remove('overflow-hidden');
        this.setState({ showPopup: false });
        this.setState({ showMoreDesState: '' });
    }



    hoverThumbnail = (key) => {
        this.setState({ isVideoThumbonHover: true, thumbnailIndex: key })
    }

    hoverOutThumbnail = () => {
        this.setState({ isVideoThumbonHover: false })
    }

    modaltoogle = (itms) => {
        this.setState({ isModel: !this.state.isModel, modaltog: itms })
        document.body.classList.add('overflow-hidden');

    }
    modaltoogleclose = (itms) => {
        this.setState({ isModel: !this.state.isModel })
        document.body.classList.remove('overflow-hidden');

    }

    render() {
        return (
            <>
                <div className="pt-3 sliderWrapperRef">
                    <div className={`row thm_slr_bx ${this.state.showPopup === true ? 'hide-animte' : 'show-animte '}`}>
                        <div className="thm_hdng_wppr d-flex align-item-center">
                            <h3 className=' d-flex align-item-center'>
                                {
                                    this.props.uniqId !== "season_list" && this.props.Itmdata.title_tag_name}
                                {this.props.uniqId === "season_list" && this.props.Itmdata.Parent_name}

                                {
                                    this.props.Itmdata.categoryid !== undefined && this.props.Itmdata.categoryid !== null && this.props.Itmdata.cat_type === 'cat' ? <Link className="viewAllBtn ml-2 d-flex align-items-center" to={{
                                        pathname: `/viewall/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '')).toLowerCase()}/${this.props.Itmdata.categoryid !== null && this.props.Itmdata.categoryid !== undefined ? this.props.Itmdata.categoryid : ''}`,
                                        state: this.props.Itmdata.title_tag_name
                                    }}><span>View All</span> <i className="fa fa-angle-right ml-1" aria-hidden="true"></i></Link> : ''
                                }
                            </h3>

                        </div>
                        <Slider {...this.state.settings} className='thumb_slider position-relative topPicks' >
                            {
                                this.props.Itmdata !== undefined && this.props.Itmdata !== null && this.props.Itmdata.search_tag !== undefined && this.props.Itmdata.search_tag !== null && this.props.Itmdata.search_tag.map((itms, key) => {

                                    let isPremium = itms.ispremium !== null && itms.ispremium === 1 ? 'thm_slr_itm_img prmum-txt' : 'thm_slr_itm_img';
                                    return (
                                        <>
                                            <div className="thm_sldr_itm" onMouseOver={(e) => this.hoverThumbnail(key)} onMouseLeave={(e) => this.hoverOutThumbnail(key)} key={key} >
                                                {
                                                    this.props.Itmdata.cat_type === "cat" ?
                                                        <>
                                                            <Link to={`/video/cat/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(this.props.Itmdata.categoryid)}`} className={`box ${isPremium}`} key={key}>
                                                                {
                                                                    this.props.Itmdata.cat_type === 'cat' ?
                                                                        <div className='placeholder hor toppick-txt-wpprPlaceholder'>
                                                                            <img alt="thumb" src={placeholder} className="w-100 placeholderImg" />
                                                                            <div className="thumbImg">
                                                                                <FadeIn height={180} >
                                                                                    {onload => (
                                                                                        <img
                                                                                            src={itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.size_default + "/width=320/height=180/quality=100"}
                                                                                            alt="" key={key}
                                                                                            onLoad={onload}
                                                                                            className="thumbPlaceholder"
                                                                                        />
                                                                                    )}
                                                                                </FadeIn>
                                                                            </div>
                                                                        </div> :
                                                                        <div className='placeholder hor'>
                                                                            <img alt="thumb" src={placeholder} className="w-100 placeholderImg" />
                                                                            <div className="thumbImg">
                                                                                <FadeIn height={180} >
                                                                                    {onload => (
                                                                                        <img
                                                                                            effect="blur"
                                                                                            src={itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.size_default + "/width=320/height=180/quality=100"}
                                                                                            alt="" key={key}
                                                                                            onLoad={onload}
                                                                                            className="thumbPlaceholder"
                                                                                        />
                                                                                    )}
                                                                                </FadeIn>
                                                                            </div>
                                                                        </div>
                                                                }
                                                            </Link>
                                                            <div className="toppick-txt-wppr">
                                                                <div className="top-str-wppr">
                                                                    <FontAwesomeIcon icon={faStar} />
                                                                    <span>Top Picks</span>
                                                                </div>
                                                                <div className="title">
                                                                    <div>

                                                                        {
                                                                            parse(itms.description !== undefined && itms.description !== null && itms.description !== '' ? itms.description.substr(0, 330) : '')
                                                                        }
                                                                    </div>

                                                                    {
                                                                        itms.description !== undefined && itms.description !== null && itms.description.length > 140 && <button type="button" className="see-mr-btn topcseemrbtn " onClick={(e) => this.showMoreDes(itms.description)}>  See More</button>

                                                                    }


                                                                    {/* {parse(                                                           
                                                        window.screen.width < 991 ? itms.description ? itms.description.substr(0,130)+'...' : ''
                                                        :
                                                        itms.description ? itms.description.substr(0,190) + '....' +  ( itms.description !== undefined && itms.description !== null && itms.description.length > 190 ? <button type='button' className='see-mr-btn topcseemrbtn'>See More</button> : '' )  : ''
                                                        
                                                    )}    */}

                                                                </div>
                                                            </div>
                                                        </>
                                                        : <Link to={`/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(this.props.Itmitms.categoryid)}`} className={`box  ${isPremium}`} key={key}>
                                                            <div className="toppick-img-wppr">
                                                                <span>
                                                                    {
                                                                        this.props.Itmdata.cat_type === 'cat' ?
                                                                            <div className='placeholder hor'>
                                                                                <img alt="thumb" src={placeholder} className="w-100 placeholderImg" />
                                                                                <div className="thumbImg">
                                                                                    <FadeIn height={180} >
                                                                                        {onload => (
                                                                                            <img
                                                                                                src={itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.size_default + "/width=320/height=180/quality=100"}
                                                                                                alt="" key={key}
                                                                                                onLoad={onload}
                                                                                                className="thumbPlaceholder"
                                                                                            />
                                                                                        )}
                                                                                    </FadeIn>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div className='placeholder hor'>
                                                                                <img alt="thumb" src={placeholder} className="w-100 placeholderImg" />
                                                                                <div className="thumbImg">
                                                                                    <FadeIn height={180} >
                                                                                        {onload => (
                                                                                            <img
                                                                                                src={itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=320/height=180/quality=100" : itms.thumburl.size_default + "/width=320/height=180/quality=100"}
                                                                                                alt="" key={key}
                                                                                                onLoad={onload}
                                                                                                className="thumbPlaceholder"
                                                                                            />
                                                                                        )}
                                                                                    </FadeIn>
                                                                                </div>
                                                                            </div>

                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="toppick-txt-wppr">
                                                                <div className="top-str-wppr">
                                                                    <FontAwesomeIcon icon={faStar} />
                                                                    <span>Top Picks</span>
                                                                </div>
                                                                <div className="title desc-main">
                                                                    {parse(itms.description !== undefined && itms.description !== null && itms.description !== '' ? itms.description.substr(0, 330) : '')}
                                                                </div>
                                                            </div>
                                                        </Link>
                                                }


                                                {/* {
                                                    this.state.isVideoThumbonHover === true && this.state.thumbnailIndex === key &&
                                                    <ZoomThumbnail callbackModel={() => this.modaltoogle(itms.trailer_data)} trailerdata={itms.trailer_data !== undefined && itms.trailer_data !== null && itms.trailer_data !== '' && itms.trailer_data.length !== 0 && itms.trailer_data.length !== 0 ? itms.trailer_data : undefined} title={itms.name} description={itms.description !== null && itms.description !== undefined ? parse(itms.description) : null} pageLink={`/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(this.props.Itmitms.categoryid)}`} playing={this.state.isVideoThumbonHover} isAddedinWishList={false} />
                                                } */}

                                                {
                                                    this.state.isVideoThumbonHover === true && this.state.thumbnailIndex === key &&
                                                    <ZoomThumbnail callbackModel={() => this.modaltoogle(itms.trailer_data)}
                                                        type={this.props.Itmdata.cat_type} entryid={itms.entryid} flag={itms.favourite_status_flag}
                                                        trailerdata={itms.trailer_data !== undefined && itms.trailer_data !== null && itms.trailer_data !== '' && itms.trailer_data.length !== 0 && itms.trailer_data.length !== 0 ? itms.trailer_data : undefined} title={itms.name} description={itms.description !== null && itms.description !== undefined ? parse(itms.description) : null} pageLink={this.props.Itmdata.cat_type === "cat" ? `/video/cat/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}` : `/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}`} playing={this.state.isVideoThumbonHover} isAddedinWishList={false} isMutedThumbnailVideo={this.state.isMutedThumbnailVideo} />
                                                }
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </Slider>
                    </div>
                </div>

                {/*popup code start here*/}
                <PopupComponents pertext={parse(this.state.showMoreDesState)} propClass={`abt-pop-wppr  ${this.state.showPopup === true ? 'show' : 'hide'}`} hidePopup={this.hidePopup} />
                {/* <div className={`abt-pop-wppr  ${this.state.showPopup === true ?'show':'hide'}`} >
                        <span className="blk-ovrly" onClick={this.hidePopup}  ></span>
                        <div class="abt-pop">
                        <button type="button" className="abt-cls-btn" onClick={this.hidePopup} ></button>
                        <div className="abt-txt">
                            {parse(this.state.showMoreDesState)}                                    
                        </div>
                        </div>
                    </div> */}
            </>
        );
    }
}
export default TopPicker;
